module.exports = __webpack_public_path__ + "static/index/img/baikal-903.ce308258.jpg";